module.exports = {
  paymentType: "Tipe Pembayaran",
  card: "Ingot / Card",
  gift: "Kado",
  characterId: "ID Karakter",
  characterName: "Nick Karakter",
  server: "Server",
  selectItem: "Pilih Item",
  confirmBtn: "OK",
  rechargeBtn: "Topup",
  inputRoleId: "Masukkan ID Karakter & Konfirmasi",
  noRoleId: "ID Karakter tidak ditemukan, mohon ulangi",
  supplementAllInfo: "Masukkan Informasi Lengkap",
  errorCharacterId: "ID Karakter Error",
  errorCharacterName: "Nick Karakter tidak boleh kosong",
  errorServer: "Server tidak boleh kosong",
  errorSelectItem: "Pilihan Item Error",
  selectPayWay: "Silahkan pilih negara Anda dan pilih metode pembayaran.",
  introduce:
    "Tentang Pembayaran： <br>1. Paket Yulgang, Paket Blessing dan Paket Classic hanya dapat dibeli satu kali dalam sehari;<br>2. Setelah memasukan ID Character, klik ¨confirm〃 lalu cek kembali nama karakter dan Server ID Anda, setelah mengecek dan tidak ada kesalahan, Anda dapat membeli dengan aman;<br>3. Jika Anda mengalami masalah pada saat melakukan pembayaran, silahkan hubungi customer service kami di FB :Yulgang Global.",
  code: {
    603: "Informasi Akun tidak ditemukan",
    606: "Item tidak ditemukan",
    607: "Channel pembayaran tidak ditemukan",
    605: "Rasio penukaran tidak diatur, hubungi CS",
    608: "ID Karakter tidak ditemukan",
    609: "Pembuatan order gagal",
    610: "Tidak dapat Topup di Server ini",
    611: "Belum membuat Karakter di Server ini, konfirmasi Akun login telah tepat",
    612: "Server tidak ditemukan",
    613: "Request Pembayaran",
    614: "Notifikasi Game Gagal",
    615: "ID Karakter yang dimasukkan tidak ditemukan"
  },
  rechargeSuccess: "Topup Selesai",
  pleaseCheck:
    "Hadiah telah dikirim ke dalam game, kembali ke game untuk memeriksa",
  resultBtn: "OK",
  someQuestions:
    "Hubungi CS melalui Facebook apabila Topup bermasalah @YulgangGlobalID"
};
